import { Link } from 'react-router-dom';
import { useMemo } from 'react';

import { Col, Row } from '@guestyci/foundation/Layout';
import createStyles from '@guestyci/foundation/createStyles';
import defaultTheme from '@guestyci/foundation/theme/defaultTheme';
import StatusIndication from '@guestyci/foundation/StatusIndication';

import utils from 'utils';
import { NavRoutes } from 'app/routes';
import whiteLogoSource from 'assets/icons/logo/gfh-logo-inline.svg';
import navigationsRoute from 'app/routes/navigationsRoute';

import NavTab from './NavTab';
import KycBanner from './KycBanner';
import DiamondMenu from './DiamondMenu';
import UserNavigationBar from './UserNavigationBar';
import ChatsWidgetContainer from '../ChatWidgets/ChatsWidgetContainer';
import SearchBarReservations from '../SearchBarReservations';

const useStyles = createStyles(
  (theme: typeof defaultTheme) => ({
    root: {
      color: theme.palette.text.primary,
      backgroundColor: 'white',
      width: '100%',
      marginBottom: '.4rem',
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'center',
      flexFlow: 'column',
      borderBottom: '1px solid #BDBDBD',
      position: 'relative',
      '& > div': {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
    },
    ul: {
      display: 'flex',
      alignItems: 'center',
      listStyleType: 'none',
      margin: '0px',
    },
    headerContainer: {
      position: 'relative',
      backgroundColor: theme.palette.primary.default,
      display: 'flex',
      flexWrap: 'wrap',
      padding: '0.375rem 0',
      boxShadow:
        '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12)',
      '& > img': {
        height: '30px',
      },
    },
  }),
  { name: 'NavTabs' }
);

const NavBar = () => {
  const classes = useStyles();
  const tabs = useMemo(
    () => NavRoutes.filter(({ configurations }) => Boolean(configurations.tab)),
    []
  );
  const { adminLogin, authenticatedData } = utils.getLocalStorageByKey(
    'adminLogin',
    'authenticatedData'
  );
  const { baseUserInfo } = authenticatedData;

  // Mobile view: Hide the top bar and menu.
  // The mobile app shows some pages from the web app in a web view. (e.g., Damage Protection).
  // When this happens, we hide the web app's menu. The native app has its own menu that is used
  // instead.
  if (window.localStorage.getItem('isMobile') === '1') {
    return (
      <div>
        <KycBanner />
      </div>
    );
  }

  // Desktop view: show the top bar and menu.
  return (
    <Col>
      <KycBanner />
      <div className={classes.root}>
        {adminLogin && (
          <StatusIndication
            variant="warning"
            text={`Impersonating ${baseUserInfo.firstName} ${baseUserInfo.lastName}`}
          />
        )}
        <div className={classes.headerContainer}>
          <Row span={2} justify="start" className="px-4">
            <Link to={navigationsRoute.IONIC_APP_HOME}>
              <img
                src={whiteLogoSource}
                alt="guesty logo"
                className="max-width-fill"
              />
            </Link>
          </Row>
          <Row span={8} justify="center">
            <SearchBarReservations />
          </Row>
          <Row span={2} justify="end" align="center">
            <DiamondMenu />
            <UserNavigationBar />
            <ChatsWidgetContainer />
          </Row>
        </div>
        <div>
          <ul className={classes.ul}>
            {tabs.map((route) => (
              <NavTab to={route.path as string} key={route.configurations.tab}>
                {route.configurations.tab}
              </NavTab>
            ))}
          </ul>
        </div>
      </div>
    </Col>

  );
};

export default NavBar;
